module.exports = __webpack_public_path__ + "f8a67436f9e4ea4dea9365fe1edd3a36.png";